import { render, staticRenderFns } from "./UResetPass.vue?vue&type=template&id=428b03ca&scoped=true&"
import script from "./UResetPass.vue?vue&type=script&lang=ts&"
export * from "./UResetPass.vue?vue&type=script&lang=ts&"
import style0 from "./UResetPass.vue?vue&type=style&index=0&id=428b03ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b03ca",
  null
  
)

export default component.exports